import { createFileRoute } from "@tanstack/react-router";
import { browseDogsFindRoute } from "@/app-clients/browse-dogs/routes/find-page-route";
import { FindRoutePage } from "@/app-clients/browse-dogs/routes/find-route-page";

export const Route = createFileRoute("/_find/find")({
    validateSearch: browseDogsFindRoute.validateSearch,
    loaderDeps: browseDogsFindRoute.loaderDeps,
    beforeLoad: browseDogsFindRoute.beforeLoad,
    loader: browseDogsFindRoute.loader,
    preload: false,
    head: browseDogsFindRoute.head,
    component: FindRoutePage,
});
